export default {
    SubordinateCompanies: {
      Header: {
        Name: '公司名称',
        Status: '状态',
        AffiliatedCompany: '所属上级公司',
        AddCompany: '新增公司'
      },
      table: {
        OrderNumber: '序号',
        CompanyCode: '公司编码',
        Name: '公司名称',
        AffiliatedCompany: '所属上级公司',
        Group: '集团',
        Status: '状态',
        Action: '操作'
      },
      Form: {
        Name: '公司名称',
        CompanyCode: '公司编码',
        Group: '所属集团',
        ParentCompany: '母公司',
        LegalPerson: '法人姓名',
        UnifiedSocialCreditCode: '统一社会信用代码',
        PictureOfBusinessLicense: '营业执照图片',
        ps: '支持JPG/JPEG/PNG格式，图片大小不超过2M',
        ps1: '请输入公司名称',
        EditCompany: '编辑公司',
        NewCompany: '新建公司'
      }
    },
};
